import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AppError } from './theme/components/app-error/error.component';

export const ROUTES: Routes = [
	{
		path: 'pages',
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'registrazione'
			},
			{
				path: 'registrazione',
				loadChildren: 'app/pages/registration/registration.module#RegistrationModule'
			}, {
				path: 'modifica',
				loadChildren: 'app/pages/update-account/update-account.module#UpdateAccountModule',
			}, {
				path: 'resetPwd',
				loadChildren: 'app/pages/resetPassword/reset-password.module#ResetPasswordModule',
			}, /* {
				path: 'recuperaBC',
				loadChildren: 'app/pages/printClub/print.club.module#PrintClubModule',
			}, */{
				path: 'error',
				component: AppError
			}, {
				path: '**',
				redirectTo: ''
			}
		]
	}, {
		path: '**',
		redirectTo: 'pages'
	}
]
export const AppRouting: ModuleWithProviders = RouterModule.forRoot(ROUTES, { /* enableTracing: true,*/  useHash: false, /*preloadingStrategy: PreloadAllModules*/ });



// WEBPACK FOOTER //
// ./src/app/app.routes.ts